import { Leaf, ShieldCheck, HeartPulse, Sparkles } from "lucide-react";

const POINTS = [
  { icon: Leaf, title: "Real, Whole Ingredients", text: "Almond flour, grass-fed butter, cage-free eggs — nothing you can't pronounce." },
  { icon: ShieldCheck, title: "Zero Added Sugar", text: "Sweetened only with maple syrup, honey & banana. Never cane sugar." },
  { icon: HeartPulse, title: "Blood-Sugar Friendly", text: "Formulated to minimize glucose spikes for diabetics and keto lifestyles." },
  { icon: Sparkles, title: "Baked to Order", text: "Small-batch, made fresh in our Tampa home studio — never mass produced." },
];

export const About = () => {
  return (
    <section id="about" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <div className="relative rounded-[2rem] overflow-hidden shadow-[0_40px_80px_-45px_rgba(45,40,37,0.4)]">
            <img
              src="/products/about-products-gemini-v5.png"
              alt="An assortment of sugar-free home-baked breads and cookies"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-olive">Our Promise</span>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-ink tracking-tight">
            Wholesome by nature,<br className="hidden sm:block" /> indulgent by design
          </h2>
          <p className="mt-5 text-[#524B46] leading-relaxed max-w-2xl">
            Healthy Home Bakery was born from a simple belief: living sugar-free shouldn't mean giving up the treats
            you love. Whether you're managing diabetes, living keto, or simply eating cleaner, every bite is crafted to
            delight without compromise.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-5">
            {POINTS.map((p) => (
              <div key={p.title} className="flex gap-4 p-5 rounded-2xl bg-white border border-[#EFE9E0]">
                <span className="grid place-items-center w-11 h-11 rounded-xl bg-[#F3F7F1] text-olive shrink-0">
                  <p.icon size={20} />
                </span>
                <div>
                  <h3 className="font-semibold text-ink">{p.title}</h3>
                  <p className="mt-1 text-sm text-[#6E6760] leading-relaxed">{p.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
